export function createHoverMarkerOverlay() {
  if (!window.google || !window.google.maps) {
    throw new Error("Google Maps API is not loaded yet.");
  }

  return class HoverMarkerOverlay extends google.maps.OverlayView {
    constructor(map) {
      super();
      this.map = map;
      this.position = null;
      this.div = null;
      this.setMap(map);
    }

    onAdd() {
      this.div = document.createElement("div");
      this.div.className = "map-hover-marker";

      const panes = this.getPanes();
      panes.overlayMouseTarget.appendChild(this.div);
    }

    onRemove() {
      if (this.div) {
        this.div.parentNode.removeChild(this.div);
        this.div = null;
      }
    }

    draw() {
      if (!this.getProjection() || !this.position || !this.div) {
        return;
      }

      // Convert the geographic lat/lng to a pixel coordinate on the screen.
      const position = this.getProjection().fromLatLngToDivPixel(this.position);
      if (!position) return;

      // Position our marker's div.
      this.div.style.left = `${position.x}px`;
      this.div.style.top = `${position.y}px`;
    }

    setPosition(position) {
      // Store the new position as a LatLng object.
      this.position = position ? new google.maps.LatLng(position) : null;
      // Call draw() to physically move the marker on the map.
      this.draw();
    }

    setVisible(visible) {
      if (this.div) {
        if (visible) {
          this.div.classList.add("visible");
        } else {
          this.div.classList.remove("visible");
        }
      }
    }
  };
}
